var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHarvest(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#e8f5e9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2e7d32",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 46V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 22c0-6 -5-10-11-10 0 6 5 10 11 10z",
    fill: "#66bb6a",
    stroke: "#2e7d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 30c0-6 5-10 11-10 0 6 -5 10 -11 10z",
    fill: "#66bb6a",
    stroke: "#2e7d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 38c0-6 -5-10-11-10 0 6 5 10 11 10z",
    fill: "#66bb6a",
    stroke: "#2e7d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 46h16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarvest);
export default __webpack_public_path__ + "static/media/harvest.c51328ec6c6924c244f2b35ef2ae3fbf.svg";
export { ForwardRef as ReactComponent };